import { useDispatch } from "react-redux";
import { AppDispatch } from "../lib/store/storeConfig";
import { fetchConveyorBox } from "../lib/store/reducers/conveyorBoxReviewReducer";
import AFrameConstants from "../lib/aframeboxlookup/Constants";
import { BarcodeFormat } from "../utils/helpers/validation";
const { LookupValueOrigin } = AFrameConstants;

export const useBarcodeScanner = () => {
  const dispatch = useDispatch<AppDispatch>();

  const loadBoxToStation = async (barcode: string) => {
    return new Promise<void>((resolve, reject) => {
      dispatch(
        fetchConveyorBox({
          type: LookupValueOrigin.ScannedBarcode,
          input: barcode.trim().toUpperCase(),
          errorCallback: reject,
          callbackFn: resolve,
        })
      );
    });
  };

  const onExecuteHigherOrderHandlerOrDefault = async (
    barcode: string,
    format: BarcodeFormat,
    defaultFn?: (barcode: string, format: BarcodeFormat) => void | Promise<void>
  ) => {
    switch (format) {
      case "SSI_SCHAEFER_CARTON":
        await loadBoxToStation(barcode);
        break;
      default:
        await defaultFn?.(barcode, format);
    }
  };

  return {
    onExecuteHigherOrderHandlerOrDefault,
  };
};
